class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.navStack = [];
  }

  connectedCallback() {
    const panels = this.querySelectorAll('.header__mobile-menu-submenu-panel');
    for (const panel of panels) {
      if (panel.parentElement !== this) {
        this.append(panel);
      }
    }

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-trigger]');
      const back = event.target.closest('[data-action="back"]');

      if (trigger) {
        const submenuId = trigger.getAttribute('data-trigger');
        const submenu = this.querySelector(`#${CSS.escape(submenuId)}`);
        if (submenu) this.openSubmenu(submenu);
        return;
      }

      if (back) {
        this.closeSubmenu();
      }
    });
  }

  openSubmenu(submenu) {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');
    if (currentNav) {
      currentNav.classList.remove('is-active');
      currentNav.classList.add('is-parent');
      this.navStack.push(currentNav);
    }

    submenu.classList.add('is-active');
    this.scrollTo(0, 0);
  }

  closeSubmenu() {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');
    const prevNav = this.navStack.pop();

    if (currentNav) {
      currentNav.classList.remove('is-active');
    }
    if (prevNav) {
      prevNav.classList.remove('is-parent');
      prevNav.classList.add('is-active');
    }
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}

